import { render, staticRenderFns } from "./chatLogScrollToBottom.vue?vue&type=template&id=289eb0d0&"
import script from "./chatLogScrollToBottom.vue?vue&type=script&lang=ts&"
export * from "./chatLogScrollToBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports